import { ModuleFE_NLPData } from './ModuleFE_NLPData.js';
export const ModulePackFE_NLPDataDB = [ModuleFE_NLPData];
//# sourceMappingURL=module-pack.js.map